import { useMemo } from 'react';
import { useQueryRoles } from '@ion/api';
import { AUTH0_USER_ROLES } from '@ion/api/auth0/roles/constants';

export default function useFormRoleSelect() {
  const { roles, loading: loading } = useQueryRoles();
  let label = 'Permission Set';
  const options = useMemo(() => {
    const filteredRoles = roles.filter(role => role.name !== AUTH0_USER_ROLES.READ_EVENTS);
    return filteredRoles.map(role => {
      return { label: role.name, value: role.id };
    });
  }, [roles]);

  if (loading) {
    label = 'Loading...';
  } else if (!options.length) {
    label = 'No Roles Available';
  }

  return { label, options };
}
